import React from 'react';
import { motion } from 'framer-motion';
import { Download } from 'lucide-react';
import StoreButtons from '../common/StoreButtons';
import './CtaSection.css';

const CtaSection = () => {
  return (
    <section className="section-padding cta-section">
      <div className="container">
        <motion.div 
          className="cta-card glass"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="cta-content text-center">
            <h2>Ready to Feel Better <span className="text-primary">Every Day?</span></h2>
            <p>Take control of stress, sleep better, and feel more balanced with Relax.</p>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <StoreButtons />
            </div>
          </div>
          
          {/* Decorative elements */}
          <div className="cta-shape shape-tl"></div>
          <div className="cta-shape shape-br"></div>
        </motion.div>
      </div>
    </section>
  );
};

export default CtaSection;
